import { useContext } from 'react';

import CatalogContext from './catalog.context';

function useCatalog() {
  const context = useContext(CatalogContext);

  if (!context) {
    throw new Error('useCatalog must be used within CatalogContext');
  }

  return context;
}

export default useCatalog;